import React, {useState} from 'react'
import {Link, navigate} from "gatsby";
import styled from 'styled-components'

import logoImg from '../../../static/images/header-mobile/images/logo-image.svg'
import burgerButton from '../../../static/images/header-mobile/images/burger-button.svg'
import ButtonStyled from "../library/Button"
import Menu from '../header-mobile/menu/Menu'

const HeaderMobile = ({path}) => {
    const [display, setDisplay] = useState(true)
    const [click, setClick] = useState(false)

    const goToContactDetails = () => {
        navigate("/contact-us/#contact-details");
    }

    return (
        <>
            <HeaderMobileStyle>
                <Link to={'/'}><Logo/></Link>
                <ActionList>
                    <ButtonStyled className={'button--mobile'} secondary type={'button'} onClick={() => goToContactDetails()}
                                  label={'Contact us'} />
                    <BurgerButton onClick={() => {setDisplay(true); setClick(true)}} />
                </ActionList>
            </HeaderMobileStyle>
            <Menu path={path} display={display} setDisplay={setDisplay} click={click}/>
        </>
    )
}

export default HeaderMobile

const HeaderMobileStyle = styled.div`
  z-index: 2;
  position: fixed;
  top: 0;
  width: 100%;
  -webkit-transform: translateZ(0);
  padding-left: 2rem;
  padding-right: 2rem;
  height: 6rem;
  background-color: white;

  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${({theme}) => theme.breakpoints.mobile_reverse} {
    display: none;
  }
`

const Logo = styled.div`
  background-image: url(${logoImg});
  background-size: contain;
  background-repeat: no-repeat;
  //background-position: center;
  width: 4.4rem;
  height: 2.8rem;
  -webkit-tap-highlight-color: transparent;
`

const ActionList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;

  .button--mobile {
    height: 4.1rem;
    line-height: 1.5rem;
    font-size: 1rem;
  }
`

const BurgerButton = styled.button`
  margin-left: 2rem;
  border: none;
  background: none;
  background-image: url(${burgerButton});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 2.4rem;
  height: 2.4rem;
`
